<mat-icon class="update-image" [svgIcon]="'update-indicator'"></mat-icon>
<app-button-advanced
  class="update-button"
  [action]="updateAction"
></app-button-advanced>
